import { IObject } from '@leafer-ui/interface'

// https://www.w3.org/TR/css-color-4/#named-colors

export const colorNames: IObject = {
    transparent: 'FFF0', // 透明色

    aliceblue: 'F0F8FF', // 爱丽丝蓝
    antiquewhite: 'FAEBD7', // 古董白
    aqua: '0FF', // 水绿色
    aquamarine: '7FFFD4', // 海洋绿
    azure: 'F0FFFF', // 天蓝色
    beige: 'F5F5DC', // 米色
    bisque: 'FFE4C4', // 米黄色
    black: '0', // 黑色
    blanchedalmond: 'FFEBCD', // 蛋白色
    blue: '00F', // 蓝色
    blueviolet: '8A2BE2', // 蓝紫色
    brown: 'A52A2A', // 棕色
    burlywood: 'DEB887', // 土褐色
    cadetblue: '5F9EA0', // 军校蓝
    chartreuse: '7FFF00', // 黄绿色
    chocolate: 'D2691E', // 巧克力色
    coral: 'FF7F50', // 珊瑚色
    cornflowerblue: '6495ED', // 矢车菊蓝
    cornsilk: 'FFF8DC', // 玉米色
    crimson: 'DC143C', // 绯红色
    cyan: '0FF', // 青色
    darkblue: '00008B', // 深蓝色
    darkcyan: '008B8B', // 深青色
    darkgoldenrod: 'B8860B', // 深金黄
    darkgray: 'A9', // 深灰色
    darkgreen: '006400', // 深绿色
    darkgrey: 'A9', // 深灰色
    darkkhaki: 'BDB76B', // 深卡其色
    darkmagenta: '8B008B', // 深洋红色
    darkolivegreen: '556B2F', // 深橄榄绿
    darkorange: 'FF8C00', // 深橙色
    darkorchid: '9932CC', // 深紫罗兰色
    darkred: '8B0000', // 深红色
    darksalmon: 'E9967A', // 深鲑鱼色
    darkseagreen: '8FBC8F', // 深海洋绿
    darkslateblue: '483D8B', // 深板岩蓝色
    darkslategray: '2F4F4F', // 深板岩灰色
    darkslategrey: '2F4F4F', // 深板岩灰色
    darkturquoise: '00CED1', // 深青绿色
    darkviolet: '9400D3', // 深紫罗兰色
    deeppink: 'FF1493', // 深粉色
    deepskyblue: '00BFFF', // 深天蓝色
    dimgray: '69', // 暗灰色
    dimgrey: '69', // 暗灰色
    dodgerblue: '1E90FF', // 道奇蓝
    firebrick: 'B22222', // 火砖色
    floralwhite: 'FFFAF0', // 花卉白
    forestgreen: '228B22', // 森林绿
    fuchsia: 'F0F', // 紫红色
    gainsboro: 'DC', // 银白色
    ghostwhite: 'F8F8FF', // 幽灵白
    gold: 'FFD700', // 金色
    goldenrod: 'DAA520', // 金棒色
    gray: '80', // 灰色
    green: '008000', // 绿色
    greenyellow: 'ADFF2F', // 黄绿色
    grey: '80', // 灰色
    honeydew: 'F0FFF0', // 蜂蜜露
    hotpink: 'FF69B4', // 热粉色
    indianred: 'CD5C5C', // 印度红
    indigo: '4B0082', // 靛蓝色
    ivory: 'FFFFF0', // 象牙色
    khaki: 'F0E68C', // 卡其色
    lavender: 'E6E6FA', // 薰衣草紫
    lavenderblush: 'FFF0F5', // 紫罗兰红
    lawngreen: '7CFC00', // 草坪绿
    lemonchiffon: 'FFFACD', // 柠檬薄纱
    lightblue: 'ADD8E6', // 浅蓝色
    lightcoral: 'F08080', // 浅珊瑚色
    lightcyan: 'E0FFFF', // 浅青色
    lightgoldenrodyellow: 'FAFAD2', // 浅金黄色
    lightgray: 'D3', // 浅灰色
    lightgreen: '90EE90', // 浅绿色
    lightgrey: 'D3', // 浅灰色
    lightpink: 'FFB6C1', // 浅粉色
    lightsalmon: 'FFA07A', // 浅鲑鱼色
    lightseagreen: '20B2AA', // 浅海洋绿
    lightskyblue: '87CEFA', // 浅天空蓝
    lightslategray: '789', // 浅板岩灰色
    lightslategrey: '789', // 浅板岩灰色
    lightsteelblue: 'B0C4DE', // 浅钢蓝
    lightyellow: 'FFFFE0', // 浅黄色
    lime: '00FF00', // 酸橙色
    limegreen: '32CD32', // 酸橙绿色
    linen: 'FAF0E6', // 亚麻色
    magenta: 'FF00FF', // 洋红色
    maroon: '800000', // 栗色
    mediumaquamarine: '66CDAA', // 中等海洋绿
    mediumblue: '0000CD', // 中等蓝色
    mediumorchid: 'BA55D3', // 中等兰花色
    mediumpurple: '9370DB', // 中等紫色
    mediumseagreen: '3CB371', // 中等海洋绿
    mediumslateblue: '7B68EE', // 中等板岩蓝色
    mediumspringgreen: '00FA9A', // 中等春绿色
    mediumturquoise: '48D1CC', // 中等青绿色
    mediumvioletred: 'C71585', // 中等紫罗兰红
    midnightblue: '191970', // 午夜蓝
    mintcream: 'F5FFFA', // 薄荷奶油色
    mistyrose: 'FFE4E1', // 薄雾玫瑰色
    moccasin: 'FFE4B5', // 鹿皮色
    navajowhite: 'FFDEAD', // 纳瓦霍白
    navy: '000080', // 海军蓝
    oldlace: 'FDF5E6', // 古董花边
    olive: '808000', // 橄榄色
    olivedrab: '6B8E23', // 橄榄褐色
    orange: 'FFA500', // 橙色
    orangered: 'FF4500', // 橙红色
    orchid: 'DA70D6', // 兰花色
    palegoldenrod: 'EEE8AA', // 苍金黄色
    palegreen: '98FB98', // 苍绿色
    paleturquoise: 'AFEEEE', // 苍绿色
    palevioletred: 'D87093', // 苍紫罗兰红
    papayawhip: 'FFEFD5', // 木瓜色
    peachpuff: 'FFDAB9', // 桃色
    peru: 'CD853F', // 秘鲁色
    pink: 'FFC0CB', // 粉色
    plum: 'DDA0DD', // 李子色
    powderblue: 'B0E0E6', // 粉蓝色
    purple: '800080', // 紫色
    rebeccapurple: '639', // 丽贝卡紫色
    red: 'F00', // 红色
    rosybrown: 'BC8F8F', // 玫瑰棕色
    royalblue: '4169E1', // 皇家蓝
    saddlebrown: '8B4513', // 鞍棕色
    salmon: 'FA8072', // 鲑鱼色
    sandybrown: 'F4A460', // 沙棕色
    seagreen: '2E8B57', // 海洋绿
    seashell: 'FFF5EE', // 海贝壳
    sienna: 'A0522D', // 黄土色
    silver: 'C0', // 银色
    skyblue: '87CEEB', // 天空蓝
    slateblue: '6A5ACD', // 板岩蓝色
    slategray: '708090', // 板岩灰色
    slategrey: '708090', // 板岩灰色
    snow: 'FFFAFA', // 雪色
    springgreen: '00FF7F', // 春绿色
    steelblue: '4682B4', // 钢蓝色
    tan: 'D2B48C', // 黄褐色
    teal: '008080', // 蓝绿色
    thistle: 'D8BFD8', // 蓟色
    tomato: 'FF6347', // 番茄色
    turquoise: '40E0D0', // 绿宝石色
    violet: 'EE82EE', // 紫罗兰色
    wheat: 'F5DEB3', // 小麦色
    white: 'F', // 白色
    whitesmoke: 'F5', // 白烟色
    yellow: 'FF0', // 黄色
    yellowgreen: '9ACD32' // 黄绿色
}